App.LoyaltyProgramsIndexController = Em.Controller.extend
  needs: [ 'loyalty-programs' ]
  loyaltyProgramsBinding: 'model'

  env:     Em.inject.service('environment')
  loyaltyEnabled: Em.computed.alias('env.features.loyaltyProgramsEnabled')

  actions:
    openLoyalty: (loyalty) ->
      @transitionToRoute 'loyalty-programs.loyalty-program.edit', loyalty.get('id')